import React, { useRef, useEffect } from 'react';
import Hero from '../Components/Hero/Hero';
import { useTranslation } from 'react-i18next';
import Experty from '../Components/Expert/Experty';
import Service from '../Components/Service/Service';
import Button2 from '../Components/Button/Button2';
import Project from '../Components/Project/Project';
import Contact from '../Components/Contact/Contact';
import "./home.css"
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
  const { t } = useTranslation();
  const dotRef = useRef(null);
  const lineRef = useRef(null);
  const containerRef = useRef(null);

  const servicesRef = useRef(null);
  const servicesLineRef = useRef(null);
  const servicesDotRef = useRef(null);

  const projectsRef = useRef(null);
  const projectsLineRef = useRef(null);
  const projectsDotRef = useRef(null);

  const contactRef = useRef(null);
  const contactLineRef = useRef(null);
  const contactDotRef = useRef(null);

  const { contextSafe } = useGSAP(() => {
    const safeTween = contextSafe(() => {
      gsap.utils.toArray(".experties-group").forEach(group => {
        gsap.from(group.children, {
          y: 50,
          opacity: 0,
          scale: 0,
          duration: 1.5,
          stagger: 0.8,
          filter: "blur(10px)",
          ease: "power3.out",
          scrollTrigger: {
            trigger: group,
            start: "top center",
            toggleActions: "play none none none",
          },
        });
      });

      gsap.utils.toArray(".services-group").forEach(group => {
        gsap.from(group.children, {
          y: 50,
          opacity: 0,
          scale: 0,
          duration: 1.5,
          stagger: 0.8,
          filter: "blur(10px)",
          ease: "power3.out",
          scrollTrigger: {
            trigger: group,
            start: "top center",
            toggleActions: "play none none none",
          },
        });
      });

      gsap.utils.toArray(".projects-group").forEach(group => {
        gsap.from(group.children, {
          y: 50,
          opacity: 0,
          scale: 0,
          duration: 1.5,
          stagger: 0.8,
          filter: "blur(10px)",
          ease: "power3.out",
          scrollTrigger: {
            trigger: group,
            start: "top center",
            toggleActions: "play none none none",
          },
        });
      });

      gsap.utils.toArray(".contact-group").forEach(group => {
        gsap.from(group.children, {
          scale: 0,
          opacity: 0,
          duration: 1.5,
          stagger: 0.8,
          ease: "power3.out",
          scrollTrigger: {
            trigger: group,
            start: "top center",
            toggleActions: "play none none none",
          },
        });
      });
    });

    gsap.set(".scroll-progress-line", { scaleY: 0 });
    gsap.to(".scroll-progress-line", {
      scaleY: 1,
      transformOrigin: "top center",
      ease: "none",
      scrollTrigger: {
        trigger: "body",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
      }
    });

    safeTween();
  }, []);

  const animateScrollLine = (container, line, dot) => {
    if (!container || !line || !dot) return;

    gsap.set(line, { height: 0 });

    gsap.to(line, {
      height: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: container,
        start: "top center",
        end: "bottom center",
        scrub: 2,
      }
    });

    gsap.to(dot, {
      top: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: container,
        start: "top center",
        end: "bottom center",
        scrub: 2,
      }
    });
  };

  useGSAP(() => {
    animateScrollLine(containerRef.current, lineRef.current, dotRef.current);
    animateScrollLine(servicesRef.current, servicesLineRef.current, servicesDotRef.current);
    animateScrollLine(projectsRef.current, projectsLineRef.current, projectsDotRef.current);
    animateScrollLine(contactRef.current, contactLineRef.current, contactDotRef.current);
  }, []);

  useEffect(() => {
    const dotRefs = [dotRef, servicesDotRef, projectsDotRef, contactDotRef];

    const updateTrail = () => {
      dotRefs.forEach(ref => {
        const dot = ref.current;
        if (!dot) return;

        const rect = dot.getBoundingClientRect();
        const x = rect.left + rect.width / 2;
        const y = rect.top + rect.height / 2;

        const trail = document.createElement("div");
        trail.style.position = "fixed";
        trail.style.left = `${x}px`;
        trail.style.top = `${y}px`;
        trail.style.border = '8px double white';
        trail.style.width = '30px';
        trail.style.height = '30px';
        trail.style.background = '#0000ff';
        trail.style.borderRadius = "50%";
        trail.style.opacity = "0.2";
        trail.style.transform = "translate(-50%, -50%)";
        trail.style.pointerEvents = "none";

        document.body.appendChild(trail);

        gsap.to(trail, {
          opacity: 0,
          scale: 1,
          duration: 1,
          ease: "power1.out",
          onComplete: () => trail.remove(),
        });
      });
    };

    gsap.ticker.add(updateTrail);
    return () => gsap.ticker.remove(updateTrail);
  }, []);
  

  return (
    <div className='bg-[#091c30] dark:bg-gradient-to-r dark:to-teal-400 dark:from-blue-700'>
<div
  className="fixed top-0 left-4 w-[4px] h-screen bg-orange-500 z-50 origin-top scroll-progress-line"
></div>

      <section id="Home" className="min-h-screen  flex items-center">
        <Hero />
      </section>

      <div>
        <h1 className='text-center expert xs:text-5xl xxs:text-4xl sm:text-6xl font-bold font-serif text-white mb-8 mt-1'>{t("BasicExperties")}</h1>
      </div>

<div ref={containerRef} className='main-pin-wrapper-expert relative '>

      <div className="sm:container mx-auto  ">
         <div className="absolute top-0 left-0 z-0 w-full h-full">
    {/* Line */}
    <div
      ref={lineRef}
      className="absolute bg-[#0000ff] w-[4px] border-white border-t-2 border-r-2 border-l-2 top-0 left-[13px] p-[2px]"
      style={{ height: '0%' }}
    ></div>

    {/* Dot */}
    <div
      ref={dotRef}
      className="w-[25px] h-[25px] rounded-full bg-[#0000ff] absolute left-[4px] z-[1] border-white border-[6px] border-double"
    ></div>
  </div>

         <div className="flex flex-wrap items-center justify-center w-full text-center">

          
  <div className="experties-group flex flex-wrap justify-center w-full">
    <Experty image={"./images/htmlLogo.png"} BarValue={"100%..."} text={t("Html")} name={t("SeeMoreE")} />
    <Experty image={"./images/cssLogo2.png"} BarValue={"70%..."} text={t("CSS")} name={t("SeeMoreE")} />
    <Experty image={"./images/jsLogo.png"} BarValue={"70%..."} text={t("JavaScript")} name={t("SeeMoreE")} />
  </div>

  <div className="experties-group flex flex-wrap justify-center w-full">
    <Experty image={""} BarValue={"100%..."} svg={          <svg class="App-logo h-40 w-60" fill='blue' viewBox="0 0 841.9 595.3" xmlns="http://www.w3.org/2000/svg"><g fill="blue"><path d="M666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9V78c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6V78.5c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zM421.2 430c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24 4.7 8 9.5 15.8 14.4 23.4zM420.7 163c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6 0-15.7 22.9-35.6 58.3-50.6 8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zM310 490c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6zM320.8 78.4z"></path><circle r="45.7" cy="296.5" cx="420.9"></circle><path d="M520.5 78.1z"></path></g></svg>}
 text={t("React")} name={t("SeeMoreE")} />
    <Experty image={"./images/nlogo.png"} BarValue={"100%..."} text={t("Node")} name={t("SeeMoreE")} />
    <Experty image={"./images/tLogo.Default"} BarValue={"80%..."} text={t("Tailwind")} name={t("SeeMoreE")} />
  </div>

</div>

        <section className='flex justify-center items-center'>
         <Button2 To={"/experties"}  />

        </section>
      </div>
      </div>

      {/* Services Section */}
      <div ref={servicesRef} className="relative  my-10">

      <div className="bg-transparent relative z-10 md:px-10 px-4 py-12 font-[sans-serif] ">
        <div className="absolute top-0 left-0 z-0 w-full h-full">
    <div ref={servicesLineRef} className="absolute bg-[#0000ff] w-[4px] border-white border-t-2 border-r-2 border-l-2 top-0 left-[13px] p-[2px]"></div>
    <div ref={servicesDotRef} className="w-[25px] h-[25px] rounded-full bg-[#0000ff] absolute left-[4px] z-[1] border-white border-[6px] border-double"></div>
  </div>
        <div className="max-w-5xl max-lg:max-w-3xl max-sm:max-w-sm mx-auto">
          <div className='my-5'>
            <h1 className='text-center expert xs:text-5xl xxs:text-4xl sm:text-6xl font-bold font-serif text-white mb-12 mt-5'>{t("OurService")}</h1>
          </div>
          <section className="services-group grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-sm:gap-8">
            <Service text={t("WebContent")} title={t("WebDevelopment")} image={"./images/web1.webp"} />
            <Service text={t("AppContent")} title={t("AppDevelopment")} image={"./images/app2.jpeg"} />
            <Service text={t("GameContent")} title={t("GameDevelopment")} image={"./images/game.jpeg"} />
          </section>
        </div>
        <section className='flex justify-center mt-8 items-center'>
            <Button2 To={"/services"} />
          </section>
      </div>
      </div>

      {/* Projects Section */}
      <div ref={projectsRef} className="relative  my-10">
<div className="absolute top-0 left-0 z-0 w-full h-full">
    <div ref={projectsLineRef} className="absolute bg-[#0000ff] w-[4px] border-white border-t-2 border-r-2 border-l-2 top-0 left-[13px] p-[2px]"></div>
    <div ref={projectsDotRef} className="w-[25px] h-[25px] rounded-full bg-[#0000ff] absolute left-[4px] z-[1] border-white border-[6px] border-double"></div>
  </div>
        <div>
          <h1 className='text-center xs:text-5xl xxs:text-4xl sm:text-6xl font-bold font-serif text-white mb-12 mt-12 '>{t("LatestProject")}</h1>
          <div className="projects-group flex flex-wrap justify-center gap-6">
            <Project img1={"./images/ziaja1.png"} img2={"./images/ziaja11.png"} img3={"./images/ziaja111.png"} />
            <Project img1={"./images/wax1.png"} img2={"./images/wax11.png"} img3={"./images/wax111.png"} />
          </div>
          <section className='flex justify-center mt-8 items-center'>
            <Button2 To={"/projects"} />
          </section>
        </div>
      </div>

      {/* Contact Section */}
      
<section ref={contactRef} className='relative z-10 contact-group pt-5 pb-10'>

        <div className="absolute top-0 left-0 z-0 w-full h-full">
    <div ref={contactLineRef} className="absolute bg-[#0000ff] w-[4px] border-white border-t-2 border-r-2 border-l-2 top-0 left-[13px] p-[2px]"></div>
    <div ref={contactDotRef} className="w-[25px] h-[25px] rounded-full bg-[#0000ff] absolute left-[4px] z-[1] border-white border-[6px] border-double"></div>
  </div>
            <h1 className='text-center xs:text-5xl xxs:text-4xl sm:text-6xl font-bold font-serif text-white  mt-12 '>{t("Contact")}</h1>

        <Contact />
      </section>
    </div>
  )
}

export default Home;
